import { useNavigate, useSearchParams } from 'react-router-dom';
import LessonForm from './components/LessonForm';

export default function NewLessonPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const studentId = params.get('student') ?? undefined;
  const isMakeup = params.get('makeup') === '1';
  const initialDate = params.get('date') ?? undefined;
  const scheduleId = params.get('schedule') ?? undefined;

  const goBack = () => navigate(studentId ? `/students/${studentId}` : '/lessons');

  return (
    <div className="mx-auto w-full max-w-3xl px-4 py-8 md:px-6 md:py-10">
      <button
        type="button"
        onClick={goBack}
        className="flex items-center gap-1 text-sm font-medium text-foreground-600 hover:text-foreground-900 whitespace-nowrap"
      >
        <i className="ri-arrow-left-line"></i>
        {studentId ? '학생관리카드' : '수업일지 목록'}
      </button>

      <h1 className="mt-4 text-2xl font-bold text-foreground-950">
        {isMakeup ? '보충 수업일지 작성' : '수업일지 작성'}
      </h1>
      <p className="mt-1.5 text-sm text-foreground-600">
        수업 일자와 범위, 다음 숙제, 테스트 범위·난이도·점수를 기록해요.
      </p>

      <div className="mt-6">
        <LessonForm
          fixedStudentId={studentId}
          initialLessonDate={initialDate}
          initialIsMakeup={isMakeup}
          makeupScheduleId={scheduleId}
          onSaved={goBack}
          onCancel={goBack}
        />
      </div>
    </div>
  );
}